import React, { useEffect, useState, useRef } from "react";
import { useSelector } from "react-redux";
import { RootState } from "../../../libraries/state_reducers/store";

interface CountdownProps {
  duration?: number; // in seconds
  suggestDuration?: number;
  onComplete?: () => void;
}

const Countdown: React.FC<CountdownProps> = ({
  duration = 5 * 60, // 2 minutes = 120 seconds
  suggestDuration,
  onComplete,
}) => {
  const countdownIsReset = useSelector(
    (state: RootState) => state.countdown.timestamp
  );

  const [timeLeft, setTimeLeft] = useState<number>(suggestDuration ?? duration);
  const [isRunning, setIsRunning] = useState<boolean>(true);
  const intervalRef = useRef<number | null>(null);

  // Countdown logic
  useEffect(() => {
    if (!isRunning || timeLeft <= 0) return;

    intervalRef.current = window.setInterval(() => {
      setTimeLeft((prev) => {
        if (prev <= 1) {
          clearInterval(intervalRef.current!);
          onComplete?.();
          return 0;
        }
        return prev - 1;
      });
    }, 1000);

    return () => clearInterval(intervalRef.current!);
  }, [isRunning, timeLeft, onComplete]);

  // Format MM:SS
  const minutes = Math.floor(timeLeft / 60);
  const seconds = timeLeft % 60;

  // Controls
  const handleReset = () => {
    if (isRunning) {
      clearInterval(intervalRef.current!);
      setTimeLeft(duration);
      setIsRunning(true);
    }
  };

  /* const handlePauseResume = () => {
    setIsRunning((prev) => !prev);
  }; */

  useEffect(() => {
    if (countdownIsReset != null) {
      console.log("reset countdown");
      handleReset();
    }
    // eslint-disable-next-line
  }, [countdownIsReset]);

  return (
    <div>
      <div>
        {minutes.toString().padStart(2, "0")}:
        {seconds.toString().padStart(2, "0")}
      </div>

      {/* <div style={{ marginTop: "10px" }}>
        <button onClick={handlePauseResume}>
          {isRunning ? "Pause" : "Resume"}
        </button>
        <button onClick={handleReset} style={{ marginLeft: "10px" }}>
          Reset
        </button>
      </div> */}
    </div>
  );
};

export default Countdown;
